import Settings from "./settings.service";
import Storage from "./storage.service";
import Helpers from "../helpers/shared.helper";
import HTTP from "./http.service";
import axios from "axios";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import CONSTANTS from "./constants.service";
import FirebaseAnalytics from "./analytics.service";
import checkModule from "../views/shared/checkModule";

const HTTPTranslations = axios.create();

var Translation = {};

var loaded = false;
let loading_new_trans = false;
var loaded_obsrv = new BehaviorSubject(loaded);
var loading_new_trans_obsrv = new BehaviorSubject(loading_new_trans);
Translation.keys = {};
var keys_obsrv = new BehaviorSubject(Translation.keys);

Translation.activeLang = "en";

window.localStorage.removeItem("preferred_languages");

let getLangCookie = Helpers?.getCookie("lang");
if (getLangCookie) {
  Translation.activeLang = getLangCookie;
}

Translation.getCurrentLanguage = () => {
  return Translation.activeLang;
};

Translation.getLanguageNativeName = (lang) => {
  if (lang === "ar") {
    return "العربية";
  }
  return "English";
};

Translation.changeLanguage = (target_lang) => {
  FirebaseAnalytics.preferred_lang_updated(target_lang);
  Translation.getTranslations(target_lang);
  Storage.set("languageUpdated", target_lang);
};

Translation.getTheOtherLanguage = () => {
  let the_other_lang = "ar";
  if (Translation.activeLang === "ar") {
    the_other_lang = "en";
  }
  return the_other_lang;
};

Translation.getTranslationsObsrv = () => {
  return loaded_obsrv;
};
Translation.getKeysObsrv = () => {
  return keys_obsrv;
};

Translation.getLoadingNewTransObsrv = () => {
  return loading_new_trans_obsrv;
};

Translation.loadBackupTranslations = (lang) => {
  Helpers.log("Using backup translations");
  let keys = {};
  if (Settings.get("version") === "_kw_onboard") {
    keys = require(`../translations/localise_stf/${lang}.json`);
  } else {
    keys = require("../translations/" + lang + ".json");
  }
  Translation.keys = keys;
  Storage.set("translations_" + lang, JSON.stringify(keys));
  Storage.set("translations_" + lang, JSON.stringify(keys), true);
  keys_obsrv.next(keys);
  loaded_obsrv.next(true);
  loading_new_trans_obsrv.next(false);
  // loaded_obsrv.complete();
};
Translation.getMenuJson = (lang) => {
  let data = {}
  if (checkModule.isHeaderKsa) {
    data = require("../translations/menu_" + lang + ".json");
    return data;
  }
  if (checkModule.isHeaderKw) {
    data = require("../translations/menu_kw_" + lang + ".json");
    return data;
  }
  
  return data
} 

Translation.fetchingBackupMenu = (lang) => {
  let data = Translation.getMenuJson(lang);
  let menus = {};
  if (Storage.get("menus", true)) {
    menus = JSON.parse(Storage.get("menus", true));
  }

  menus[lang] = data.data;
  menus["created_at"] = Date.parse(new Date());
  menus["version"] = Settings["menu_version"];

  Storage.set("menus", JSON.stringify(menus), true);
};
Translation.loadBackupMenu = (lang) => {
  let menus = Storage.get("menus", true) || {};

  if (menus[lang]) {
    let y2k = Date.parse(new Date(menus["created_at"]));
    let today = Date.parse(new Date());
    // let today= Date.parse("Feb 25, 2019");

    if (
      Helpers.dateDiff("n", y2k, today) + 1 >
      Settings["data_expiry_duration"] ||
      menus["version"] !== Settings["menu_version"]
    ) {
      Translation.fetchingBackupMenu(lang);
    }
  } else {
    Translation.fetchingBackupMenu(lang);
  }
};

Translation.fetchingMenu = (lang) => {
  let config = {
    method: "get",
    url: Settings.menu_api + "&lang=" + lang,
  };
  HTTPTranslations(config)
    .then((response) => {
      let menus = {};
      menus[lang] = response.data;
      menus["created_at"] = Date.parse(new Date());
      menus["version"] = Settings["menu_version"];
      Storage.set("menus", JSON.stringify(menus), true);
    })
    .catch((error) => {
      Translation.loadBackupMenu(lang);
    });
};

Translation.getMenu = (lang) => {
  let menus = JSON.parse(Storage.get("menus", true)) || {};

  if (menus[lang]) {
    let y2k = Date.parse(new Date(menus["created_at"]));
    let today = Date.parse(new Date());
    // let today= Date.parse("Feb 25, 2019");

    if (
      Helpers.dateDiff("n", y2k, today) + 1 >
      Settings["data_expiry_duration"] ||
      menus["version"] !== Settings["menu_version"]
    ) {
      Translation.fetchingMenu(lang);
    } else {
      Storage.set("menus", JSON.stringify(menus), true);
    }
  } else {
    Translation.fetchingMenu(lang);
  }
};

// const callTranslationAPI = (lang) => {
//   let config = {
//     method: "get",
//     url: "/translations",
//     params: {
//       container_id: Settings.translations_container,
//       lang: lang,
//     },
//   };
//   HTTP(config)
//     .then((data) => {
//       if (data.data) {
//         if (
//           data.data.message &&
//           data.data.message.indexOf("Controller") !== -1
//         ) {
//           Helpers.log(data);
//           Translation.loadBackupTranslations(lang);
//         } else {
//           Helpers.log("Using api translations");

//           Translation.keys = data.data;
//           keys_obsrv.next(data.data);
//           Storage.set("translations_" + lang, data.data);
//           Translation.activeLang = lang;
//           loaded_obsrv.next(true);
//           loading_new_trans_obsrv.next(false);
//           // loaded_obsrv.complete();
//         }
//       } else {
//         Helpers.log(data);
//         Translation.loadBackupTranslations(lang);
//       }
//     })
//     .catch((error) => {
//       Helpers.log(error);
//       Translation.loadBackupTranslations(lang);
//     });
// };

const callLokaliseTranslationAPI = (lang) => {
  Storage.set("translationLoading", true);
  let lang_ids = ``;
  if (lang !== "en") {
    lang_ids += Settings.country && Settings.country === "KW" ? `720` : `714`;
  } else {
    lang_ids += Settings.country && Settings.country === "KW" ? `1055` : `640`;
  }
  let config = {
    method: "get",
    url: "/translations/lokalize_by_project_id",
    params: {
      lang: lang_ids,
      project_id: Settings.project_id,
    },
  };
  HTTP(config)
    .then((data) => {
      const translations = data.data.keys.reduce(
        (accumulator, item) => ({
          ...accumulator,
          [item.key_name.web]: item.translations[0].translation,
        }),
        {}
      );
      Translation.keys = translations;
      Storage.set("translations_" + lang, JSON.stringify(translations));
      Storage.set("translations_" + lang, JSON.stringify(translations), true);

      // Storage.set(
      //   "translations_session_" + lang,
      //   JSON.stringify(translations),
      //   true
      // );
      keys_obsrv.next(translations);
      loaded_obsrv.next(true);
      loading_new_trans_obsrv.next(false);
      Storage.set("translationLoading", false);
    })
    .catch((error) => {
      Helpers.log(error);
      Translation.loadBackupTranslations(lang);
      Storage.set("translationLoading", false);
    });
};

Translation.getTranslations = (lang) => {
  Storage.set("translationLoading", true);
  Helpers.setCookie("lang", lang);

  Translation.getMenu(lang);
  loading_new_trans_obsrv.next(true);
  Translation.activeLang = lang;

  let from_storage = Storage.get("translations_" + lang) || Storage.get("translations_" + lang, true);
  let build_version = Storage.get("build_version", true);
  let updatedBuildVersion = CONSTANTS.BUILD_VERSION;
  Storage.clear("citcPdfForPlans")
  if (from_storage && build_version && build_version === updatedBuildVersion) {
    from_storage = JSON.parse(from_storage)
    Translation.keys = from_storage;
    keys_obsrv.next(from_storage);
    loaded_obsrv.next(true);
    loading_new_trans_obsrv.next(false);
    Storage.set("translationLoading", false);
  } else {
    Storage.set("build_version", updatedBuildVersion, true);
    callLokaliseTranslationAPI(lang);
  }
};

Translation.setAdditonalKeysTesting = (additional) => {
  // let additional={

  // };
  let additionalKeysCombined = {
    ...Translation.keys,
    ...additional,
  };
  Translation.keys = { ...additionalKeysCombined };
  keys_obsrv.next(additionalKeysCombined);
};

export default Translation;
